import React, { Component, Fragment } from 'react';
import FETCH from '../Fetch';
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
import { numberFormat } from '../utils';
import { Link } from 'react-router-dom';
import { toast } from './Notifier';
import AccomodationDetailsLoader from '../loaderComponents/AccommodationDetailsLoader';
import AccommodationDetailsMap from './AccommodationDetailsMap';

class EmptyAccommodations extends React.Component {
  render() {
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1 className="small">Error</h1>
        {/* card for registered courses display  */}
        <div className="row no-gutters">
          <div className="col-lg-12 ">
            <div className="card row justify-content-center align-items-center min-h-500 not-found">
              <div className="status-code"> Sorry </div>
              <div className="status-text">
                {' '}
                {this.props.message
                  ? this.props.message
                  : 'Server could not be reached, check network connectivity'}
              </div>
              <Link
                className="btn btn-primary btn-primary-color not-found-btn"
                to="/"
              >
                Back To Home
              </Link>
            </div>
            {/* card for outstanding fees */}
          </div>
        </div>
        {/* end card for news display   */}
      </main>
    );
  }
}

class AccomodationDetails extends Component {
  state = {
    accommodationData: null
  };

  componentDidMount() {
    const {
      match: { params }
    } = this.props;

    FETCH.getAccmodationDetails(params.accommodationId).then(res => {
      if (res.status === 'error') {
        toast(
          res.message
            ? res.message
            : 'Server could not be reached, check network connectivity',
          { status: 'error', timeout: 36000 }
        );
        return this.setState({
          accommodationData: null,
          error: true,
          message: res.message
        });
      }
      this.setState({
        accommodationData: res.data,
        is_booked: !!res.data.is_booked
      });
    });
  }

  render() {
    return this.state.error ? (
      <EmptyAccommodations message={this.state.message} />
    ) : (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1>Accomodation Details</h1>
        {/* card for acconmodation details */}
        {this.state.accommodationData ? (
          <div className="row  no-gutters">
            <div className="col-lg-12">
              <div className="card  min-h-700">
                <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-3">
                      Hostel Details
                    </div>
                  </div>
                </div>
                <div className="card-body accomodation-details p-0 m-0 ">
                  <div className="hostel-image-cont">
                    <img
                      src={require('../assets/hostel-details-image.png')}
                      className="w-100"
                      alt="hostel-avatar"
                    />
                  </div>
                  <div className="content col">
                    <div className="hostel-details row">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                        <div className="title">
                          <span>
                            {this.state.accommodationData.hostel_name}
                          </span>
                        </div>
                        <div className="description" />
                        <div className="hostel-details-info">
                          <span className="info-text-icon">
                            <span className="info-icon">
                              <img
                                src={require('../assets/bed-space.svg')}
                                alt="info icon"
                              />
                            </span>
                            <span className="info-text">
                              Bed Space:{' '}
                              {this.state.accommodationData.total_bed_spaces}
                            </span>
                          </span>
                          {/* <span className="info-text-icon">
                                                    <span className="info-icon">
                                                        <img src={require("../assets/bed-space.svg")} alt="info icon" />
                                                    </span>
                                                    <span className="info-text">
                                                        Baths: 1
                                                     </span>
                                                </span>
                                                <span className="info-text-icon">
                                                    <span className="info-icon">
                                                        <img src={require("../assets/bed-space.svg")} alt="info icon" />
                                                    </span>
                                                    <span className="info-text">
                                                        Wardrobe: 2
                                                    </span>
                                                </span>
                                                <span className="info-text-icon">
                                                    <span className="info-icon">
                                                        <img src={require("../assets/wifi.svg")} alt="info icon" />
                                                    </span>
                                                    <span className="info-text">
                                                        Free Wifi
                                                    </span>
                                                </span> */}
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                        <div className="price-details">
                          <div className="price">
                            {numberFormat(this.state.accommodationData.amount)}{' '}
                            <span className="naira-sign"> NGN</span>
                          </div>

                          <a
                            className="btn  btn-primary btn-primary-color book-btn"
                            data-toggle="modal"
                            data-target="#bookspacePopup"
                            href="##"
                          >
                            {!this.state.is_booked
                              ? 'Book a Bed Space'
                              : this.state.accommodationData.has_paid
                              ? 'View reservation'
                              : 'Booking details'}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="hostel-location-overview row ">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="location">
                          <h3 className="heading">Location</h3>
                          <div className="address-map">
                            <div className="address">
                              <span className="address-image">
                                <img
                                  src={require('../assets/map.svg')}
                                  alt="location-icon"
                                />
                              </span>
                              <span className="address-text">
                                {this.state.accommodationData.address} ,
                                <b> {this.state.accommodationData.location} </b>
                              </span>
                            </div>
                            {/* <Map
                              lng={this.state.accommodationData.longtitude}
                              lat={this.state.accommodationData.latitude}
                              hostel_name={
                                this.state.accommodationData.hostel_name
                              }
                              address={this.state.accommodationData.address}
                            /> */}
                            <div
                              style={{
                                height: 240,
                                position: 'relative'
                              }}
                            >
                              <AccommodationDetailsMap
                                lat={this.state.accommodationData.latitude}
                                lng={this.state.accommodationData.longtitude}
                                address={this.state.accommodationData.address}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="overview">
                          <h3 className="heading">Overview</h3>
                          <div className="overview-content">
                            <p>{this.state.accommodationData.overview}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* card for accomodation details */}
              </div>
            </div>
            {/* end card for news display   */}
            <PopuModal
              hostel_id={this.state.accommodationData.hostel_id}
              is_booked={this.state.is_booked}
              has_paid={this.state.accommodationData.has_paid}
              paid_id={this.state.accommodationData.paid_id}
            />
          </div>
        ) : (
          <AccomodationDetailsLoader />
        )}

        {/* Book a bedspace Pop-up */}

        {/* End Book a bedspace Pop-up */}

        {/* booking details modal */}

        {/* end modal body */}
      </main>
    );
  }
}

class PopuModal extends Component {
  state = {
    hostel_id: '',
    bookingSuccessful: false,
    requestingForAccommodation: false,
    requestingForCouponReserve: false,
    is_booked: this.props.is_booked,
    has_paid: this.props.has_paid,
    isUpdatingRef: false,
    coupon_code: '',
    receipt_url: ''
  };

  componentDidMount() {
    if (this.state.is_booked && !this.state.bookingData) {
      FETCH.getBooking().then(response => {
        this.setState({
          bookingData: response.data,
          paymentDetails: response.paymentDetails
        });
      });
    }
  }

  bookAccommodation = e => {
    e.preventDefault();
    this.setState({ requestingForAccommodation: true });
    FETCH.bookAccommodation({
      hostel_id: this.props.hostel_id
    }).then(response => {
      if (response.status === 'success') {
        toast(response.message, { status: 'success' });
        this.setState({
          hostel_id: this.props.hostel_id,
          bookingSuccessful: true,
          bookingData: response.data,
          paymentDetails: response.paymentDetails,
          is_booked: true,
          requestingForAccommodation: false
        });
        return;
      }
      this.setState({
        requestingForAccommodation: false,
        is_booked: false,
        hasBookingError: true,
        bookingError: response.message
      });

      toast(response.message, { status: 'error', timeout: 3600 });
    });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  reserveWithCoupon = e => {
    e.preventDefault();
    /*
     * return processing already
     */
    if (this.state.requestingForCouponReserve) return;

    const { coupon_code } = this.state;
    if (this.state.coupon_code.trim() !== '') {
      this.setState({ requestingForCouponReserve: true });
      FETCH.BookWithCoupon({
        coupon_code: coupon_code,
        hostel_id: this.props.hostel_id
      })
        .then(response => {
          if (response.status === 'success') {
            toast(response.message, { status: 'success' });
            this.setState({ coupon_code: '' });
            this.setState({
              hostel_id: this.props.hostel_id,
              bookingSuccessful: true,
              bookingData: response.data,
              paymentDetails: response.paymentDetails,
              is_booked: true,
              requestingForCouponReserve: false
            });
          } else {
            this.setState({
              requestingForCouponReserve: false,
              is_booked: false,
              hasBookingError: true,
              bookingError: response.message
            });
            toast(response.message, { status: 'error' });
          }
        })
        .catch(error => {
          this.setState({ requestingForCouponReserve: false });
          toast('Server could not be reached, check network connectivity', {
            status: 'error',
            timeout: 36000
          });
        });
    } else {
      toast('please enter a coupon code', { status: 'error' });
    }
    // toast("coupon cannot be processed at the moment", { status: "error" });
  };

  handlePayment = () => {
    this.setState({ isUpdatingRef: true });

    this.updateAccommodationRef()
      .then(response => {
        if (response.status === 'success') {
          /*
           * return if empty rrr
           */
          if (!this.state.paymentDetails.rrr || !this.state.paymentDetails) {
            toast(
              'Error generating Remita Retrieval Reference, Please try again later',
              { status: 'error' }
            );
            return;
          }
          return this.handlePaymentForm.submit();
        } else if (response.status === 'error') {
          this.setState({ isUpdatingRef: false });
          if (Object.keys(response.message).length) {
            Object.keys(response.message).forEach(key => {
              toast(response.message[key], { status: 'error' });
            });
          } else toast(response.message, { status: 'error' });
        }
      })
      .catch(err => {
        this.setState({ isUpdatingRef: false });
        toast(err.message, { status: 'error' });
      });
  };

  updateAccommodationRef = () => {
    if (!this.state.paymentDetails) {
      this.setState({ isUpdatingRef: false });
      toast('An error occured, please try again later', { status: 'error' });
      // throw 'An error occured, please try again later';
    }
    let data = {
      rrr_code: this.state.paymentDetails.rrr,
      trans_ref: this.state.paymentDetails.order_id,
      booking_id: this.state.bookingData.booking_id
    };
    return FETCH.UpdateAccommodationRef(data).then(response => {
      return response;
    });
  };
  render() {
    return (
      <div
        className="modal fade accomodation-bookspace-modal"
        id="bookspacePopup"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content ">
            {/* modal title */}
            <div className="modal-header title justify-content-center">
              <h5 className="modal-title title-text" id="exampleModalLongTitle">
                {!this.state.is_booked ? 'Book a Bed Space' : 'Booking Details'}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={el => (this.closeButton = el)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {/* end modal title */}
            {/* begin modal body */}
            {!this.state.is_booked ? (
              <div className="modal-body">
                <form className="modal-form login-box">
                  <div className="form-group mb-35">
                    {/* {this.state.hasBookingError ? (
                      <div className="alert alert-danger">
                        {this.state.bookingError}
                      </div>
                    ) : (
                      ""
                    )} */}
                    <button
                      className="position-relative btn w-100 btn-primary-big active book-btn"
                      onClick={this.bookAccommodation}
                      style={{
                        backgroundColor: this.state.requestPending
                          ? '#02750e'
                          : '#00d715'
                      }}
                    >
                      {this.state.requestingForAccommodation ? (
                        <i className="fas fa-circle-notch fa-spin" />
                      ) : (
                        'Request for reservation'
                      )}
                    </button>
                  </div>
                  <div className="divider text-center">
                    <span className="divider-text">or</span>
                  </div>
                  <div className="form-group mb-35">
                    <label htmlFor="couponCode" className="form-label">
                      Reserve with Coupon
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="couponCode"
                      name="coupon_code"
                      value={this.state.coupon_code}
                      onChange={this.handleChange}
                      aria-describedby="coupon Code"
                      placeholder="Enter Coupon Code"
                    />
                    <button
                      style={{
                        color: 'black'
                      }}
                      className="btn  btn-primary btn-primary-color  w-100 book-btn"
                      onClick={this.reserveWithCoupon}
                    >
                      {this.state.requestingForCouponReserve ? (
                        <i className="fas fa-circle-notch fa-spin" />
                      ) : (
                        'Reserve with coupon'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <Fragment>
                <div className="modal-body">
                  <div className="card-body p-0 m-0">
                    <div className="table-responsive">
                      <table className="table transaction-history">
                        <thead />
                        <tbody>
                          <tr>
                            <td className="pl-41 text border-top-0">
                              Hostel Name
                            </td>
                            <td className="text border-top-0">
                              {this.state.bookingData
                                ? this.state.bookingData.hostel_name
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Unit Number</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.unit_number
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Block Number</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.block_number
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Room Number</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.room_number
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Bed Space</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.bed_space
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Amount</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.amount
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Booking Reference</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.booking_reference
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Booking Time</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.booking_time
                                : 'null'}
                            </td>
                          </tr>
                          <tr>
                            <td className="pl-41 text">Booking Expires</td>
                            <td className="text">
                              {this.state.bookingData
                                ? this.state.bookingData.booking_expires
                                : 'null'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {this.state.paymentDetails ? (
                        <Fragment>
                          <form
                            action={this.state.paymentDetails.finalize_url}
                            id="remita_form"
                            name="remita_form"
                            method="POST"
                            ref={el => (this.handlePaymentForm = el)}
                          >
                            <input
                              id="merchantId"
                              name="merchantId"
                              defaultValue={
                                this.state.paymentDetails.merchant_id
                              }
                              type="hidden"
                            />
                            <input
                              id="rrr"
                              name="rrr"
                              defaultValue={this.state.paymentDetails.rrr}
                              type="hidden"
                            />
                            <input
                              id="responseurl"
                              name="responseurl"
                              defaultValue="{{data.responseurl}}"
                              type="hidden"
                            />
                            <input
                              id="hash"
                              name="hash"
                              defaultValue={this.state.paymentDetails.hash}
                              type="hidden"
                            />
                            <input
                              id="paymenttype"
                              name="paymenttype"
                              defaultValue={this.state.paymentMethod}
                              type="hidden"
                            />
                          </form>
                        </Fragment>
                      ) : null}
                    </div>
                  </div>
                </div>
                {this.props.has_paid ? (
                  <a
                    className="position-relative btn w-100 btn-primary-big active book-btn"
                    href={`${
                      this.state.bookingData
                        ? this.state.bookingData.receipt_url +
                          `${this.state.bookingData.paid_id}`
                        : ''
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Print reciept
                  </a>
                ) : (
                  <button
                    className="position-relative btn w-100 btn-primary-big active book-btn"
                    onClick={this.handlePayment}
                  >
                    {this.state.isUpdatingRef ? (
                      <i className="fas fa-circle-notch fa-spin" />
                    ) : (
                      'Make payment'
                    )}
                  </button>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// class Map extends Component {
//   componentDidMount() {
//     var mymap = L.map("map").setView(
//       [parseFloat(this.props.lng), parseFloat(this.props.lat)],
//       13.0
//     );
//     L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
//       attribution:
//         'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap |<a href="https://www.mapbox.com/">Mapbox</a>',
//       maxZoom: 18
//     }).addTo(mymap);
//     var marker = L.marker([
//       parseFloat(this.props.lng),
//       parseFloat(this.props.lat)
//     ]).addTo(mymap);
//     marker
//       .bindPopup(`<b>${this.props.hostel_name}</b><br>${this.props.address}`)
//       .openPopup();
//   }

//   render() {
//     return (
//       <div className="map">
//         <div
//           id="map"
//           style={{
//             height: 240,
//             position: "relative",
//             backgroundColor: "grey"
//           }}
//         />
//       </div>
//     );
//   }
// }

export default AccomodationDetails;
